(function () {
    'use strict';
    angular
            .module('imnApp')
            .factory('UserData', UserData);

    UserData.$inject = ['UserService', 'Authenticate'];

    function UserData(UserService, Authenticate) {

        return {
            id: null,
            groupName: null,
            isAuthenticated: false,
            sessionExpired: false,
            getCurrentUser: getCurrentUser,
            reset: reset,
            expireSession: expireSession,
            permissions: null
        };

        function getCurrentUser() {

            var _this = this;

            return UserService.getCurrentUser().then(successUser);

            function successUser(data) {
                _this.groupName = data.groupName;
                _this.id = data.id;
                _this.isAuthenticated = true;
                _this.sessionExpired = false;
                _this.permissions = data.permissions;

                // stores permissions in a factory for sharing.
                Authenticate.setPermissions(_this.permissions);

                return data;
            }

        }

        function reset() {
            this.id = null;
            this.groupName = null;
            this.isAuthenticated = false;
            this.sessionExpired = false;
        }

        function expireSession() {
            this.sessionExpired = true;
        }

    }
})();